import type { SearchResultOrder } from '@iconik-io/iconik-api/src/services/search';

import { MAX_PAGE_SIZE } from '../../constants/page_size';

export const NATURAL_SEARCH_RESULT_UNIT = 'asset' as const;

export const NATURAL_SEARCH_MAX_SUB_ITEMS = 20;

/** The largest page a natural search asks for, as for any other search. */
export const NATURAL_SEARCH_MAX_PER_PAGE = MAX_PAGE_SIZE;

export const NATURAL_SEARCH_QUERY_PARAM = 'natural_search';

/**
 * The orders a natural-search answer can be shown in. The search ranks by
 * relevance itself, so the regular sort fields do not apply to it.
 */
export const NATURAL_SEARCH_ORDER_LABELS: Record<SearchResultOrder, string> = {
  relevance: 'Relevance',
  recent: 'Newest',
};
